import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import SimpleBar from 'simplebar-react';
import { APIClient } from '../../helpers/ApiHeleps';
import AddGoalModal from './AddGoalModal';
import AddNeedAndGapModal from './AddNeedAndGapModal';
import NeedGridComponent from './NeedGridComponent';
import UntagModal from './UntagModal';
import { needPayLoadWithRaw, prepareListOfTree, typeOfNeeds } from './utils';
import { useSelector } from 'react-redux';
import { convertToLowerCase } from '../../Components/Common/Util';

const NeedMappingModal = ({ show, onCloseClick, needsData }) => {
    const api = new APIClient();
    const userCredential = useSelector((state) => state.CommonStore.loginToken);
    const [showAddNeedModal, setShowAddNeedModal] = useState(false);
    const [goalForm, setGoalForm] = useState({ goal: '' });
    const [showUntagModal, setShowUntagModal] = useState(false);
    const [untagedObj, setUntagedObj] = useState({});
    const [editGoalObj, setEditGoalObj] = useState();
    const [editGoalModal, setEditGoalModal] = useState(false);
    const [modeOfAction, setModeOfAction] = useState('');
    const [activeSubCatId, setActiveSubCatId] = useState('');
    const [initialValues, setIntialValues] = useState({ category: '', subCategory: '' });
    const [rawData, setRowData] = useState([]);
    const [load, setLoad] = useState(false);
    const [treeList, setTreeList] = useState([]);

    const fetchNeeds = async () => {
        try {
            setLoad(true);
            let resp = await api.get(`${needsData?.uniquelink}/needs`, userCredential);
            if (resp?.status === 200 && resp?.data?.isSuccess) {
                setRowData(resp?.data?.data);
                setTreeList(prepareListOfTree(resp?.data?.data));
                setLoad(false);
            } else if (!resp?.data?.isSuccess) {
                toast.error('API failed try again.');
                setLoad(false);
            }
        } catch (err) {
            toast.error('Something went wrong please try again');
            setLoad(false);
        }
    };

    useEffect(() => {
        needsData?.uniquelink && fetchNeeds();
    }, []);

    const handleEditGoal = (label, id) => {
        setEditGoalObj({
            goal: label,
            id: id,
            uniquelink: needsData?.uniquelink
        });
        setGoalForm({ goal: label });
        setEditGoalModal(true);
    };

    const handleAddGoalOrActionItem = (data, type) => {
        let obj = {};
        if (type === 'Goal') {
            obj = {
                category: {
                    icD10Id: data.categoryId,
                    icD10Desc: data.category
                },
                subCategory: [
                    {
                        icD10Id: data.subCategoryId,
                        icD10Desc: data.subCategory,
                        goals: []
                    }
                ]
            };
            setActiveSubCatId(data.subCategoryId);
        }

        switch (type) {
            case 'Goal':
                setShowAddNeedModal(true);
                setModeOfAction('Add Goal');
                setIntialValues(obj);
                break;
            case 'Untag':
                setUntagedObj(data);
                setShowUntagModal(true);
                break;

            default:
                break;
        }
    };

    const updateGoal = async (data) => {
        try {
            setLoad(true);
            let resp = await api.update(`${needsData?.uniquelink}/needs`, userCredential, data);
            if (resp.data?.isSuccess) {
                toast.success('Goal added successfully.');
                setEditGoalObj({});
                setGoalForm({ goal: '' });
                setLoad(false);
                setEditGoalModal(false);
                fetchNeeds();
            } else if (!resp.data?.isSuccess) {
                toast.error('Api failed please try again.');
                setLoad(false);
            }
        } catch (error) {
            toast.error('Something went wrong please try again');
            setLoad(false);
        }
    };

    const untagApiCall = async (body) => {
        try {
            setLoad(true);
            let resp = await api.update(`${needsData?.uniquelink}/needs`, userCredential, body);
            if (resp.data?.isSuccess) {
                toast.success('Subcategory untagged successfully.');
                fetchNeeds();
                setUntagedObj({});
                setShowUntagModal(false);
                setLoad(false);
            } else if (!resp.data?.isSuccess) {
                toast.error('Api failed please try again.');
                setLoad(false);
            }
        } catch (error) {
            toast.error('Something went wrong please try again');
            setLoad(false);
        }
    };

    const untagHandler = (untagId) => {
        let updatedData = rawData?.map((item) => {
            if (item?.needSubCategoryIcd10Id === untagedObj?.subCategoryId) {
                return { ...item, needType: typeOfNeeds.untag, untagReasonId: untagId };
            }
            return { ...item, untagReasonId: 0 };
        });

        let payLoad = needPayLoadWithRaw(updatedData, needsData?.uniquelink);
        untagApiCall(payLoad);
    };
    return (
        <>
            <Modal isOpen={show} toggle={onCloseClick} centered={true} size="xl">
                <ModalHeader className="bg-soft-primary">Needs</ModalHeader>
                <ModalBody className="py-3 px-5">
                    <div className="d-flex align-items-center mb-2">
                        <h4 className="mt-2">Add Need</h4>
                        {!(convertToLowerCase(needsData?.status) === 'approved') && (
                            <button
                                type="button"
                                className="btn btn-soft-primary btn-sm mx-2 rounded-pill sm-btn "
                                onClick={() => {
                                    setShowAddNeedModal(true);
                                    setModeOfAction('');
                                    setIntialValues({ category: '', subCategory: '' });
                                }}
                                id="addNeeds"
                                title="Add Needs"
                            >
                                <i className="ri-add-fill fs-18 fw-bold"></i>
                            </button>
                        )}
                    </div>
                    <SimpleBar className="max-height-600">
                        <NeedGridComponent
                            tableViewData={treeList}
                            handleAddGoalOrActionItem={handleAddGoalOrActionItem}
                            handleEditGoal={handleEditGoal}
                            loading={load}
                            rowStatus={convertToLowerCase(needsData?.status)}
                        />
                    </SimpleBar>

                    <div className="d-flex justify-content-end mt-4">
                        <div>
                            <button type="button" className="btn btn-md btn-outline-primary" id="gapsCancel" onClick={onCloseClick}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </ModalBody>
                {showAddNeedModal && (
                    <AddNeedAndGapModal
                        show={showAddNeedModal}
                        onCloseClick={() => setShowAddNeedModal(false)}
                        modeOfAction={modeOfAction}
                        rowTreeList={rawData}
                        // setData={setData}
                        activeSubCatId={activeSubCatId}
                        initialValues={initialValues}
                        setActiveSubCatId={setActiveSubCatId}
                        row={needsData}
                        fetchNeeds={fetchNeeds}
                        treeList={treeList}
                    />
                )}
                {editGoalModal && (
                    <AddGoalModal
                        show={editGoalModal}
                        load={load}
                        onCloseClick={() => setEditGoalModal(false)}
                        rawData={rawData}
                        treeList={treeList}
                        editGoalObj={editGoalObj}
                        goalFormObj={goalForm}
                        handleSucess={updateGoal}
                    />
                )}
                {/* {showUntagModal && (
                    <ConfirmationPopup
                        show={showUntagModal}
                        onCloseClick={() => setShowUntagModal(false)}
                        confirmText={
                            <p>
                                Are you sure want to untag <span className="text-danger fw-medium">{untagedObj?.subCategory}</span>{' '}
                                subcategory ?
                            </p>
                        }
                        handleSubmit={() => !load && untagHandler()}
                    />
                )} */}
                {showUntagModal && (
                    <UntagModal
                        show={showUntagModal}
                        onCloseClick={() => setShowUntagModal(false)}
                        loading={load}
                        formSubmit={untagHandler}
                    />
                )}
            </Modal>
        </>
    );
};
export default NeedMappingModal;
